<template>
<div>
    <Breadcrumbs main="Admin" submain="Course" title="E-Book" />
    <!-- Container-fluid starts -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New E-Book</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="e_book_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="min-width: 200px; max-width: 400px; display: flex; flex-direction: column; gap: 6px;">
                                            <h7>{{ row.item.title }}</h7>
                                            <h7 v-if="row.item.link">
                                                <a
                                                    :href="row.item.link"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style="
                                                        display: inline-block;
                                                        padding: 2px 14px;
                                                        border-radius: 999px;
                                                        background: #f0f4ff;
                                                        color: #2563eb;
                                                        text-decoration: underline;
                                                        font-weight: 500;
                                                        font-size: 13px;
                                                        transition: background 0.2s;
                                                    "
                                                >
                                                    View E-Book
                                                </a>
                                            </h7>
                                        </div>
                                    </template>

                                    <template #cell(description)="row">
                                        <div v-if="row.item.description" style="max-width: 500px;">
                                            <div>
                                                <span v-if="row.item.description && row.item.description.length > 200">
                                                    {{ row.item.description.slice(0, 200) }}...
                                                </span>
                                                <span v-else>
                                                    {{ row.item.description }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(thumbnail)="row">
                                        <div v-if="row.item.thumbnail" style="min-width: 120px;">
                                            <img style="max-height: 100px;" :src="host + row.item.thumbnail" alt="">
                                        </div>
                                    </template>

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCourse(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCourse(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- E-Book Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add E-Book" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter e-book title" v-model="e_book.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter e-book link" v-model="e_book.link">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" placeholder="Enter e-book description" v-model="e_book.description" rows="4"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Thumbnail Image</label>
                        <input type="file" accept="image/*" @change="onImageChange($event, 'thumbnail')" />
                    </div>
                    <div v-if="thumbnailPreview">
                        <img :src="thumbnailPreview" alt="Thumbnail Preview" style="max-width: 100%; max-height: 120px; margin-top: 8px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- E-Book Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit E-Book" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter e-book title" v-model="edit_e_book.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter e-book link" v-model="edit_e_book.link">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" placeholder="Enter e-book description" v-model="edit_e_book.description" rows="4"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div style="display: flex; flex-direction: column;">
                        <label>Thumbnail Image</label>
                        <input type="file" accept="image/*" @change="onImageChangeEdit($event, 'thumbnail')" />
                    </div>
                    <div v-if="thumbnailPreview" style="margin-top: 20px;">
                        <img :src="thumbnailPreview" alt="Thumbnail Preview" style="max-width: 100%; max-height: 120px;" />
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- E-Book Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this e-book?</div>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'thumbnail',
                    label: 'Thumbnail',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            e_book: {
                title: "",
                link: "",
                description: "",
                thumbnail: null
            },
            edit_e_book: {
                id: null,
                title: "",
                link: "",
                description: "",
                thumbnail: null
            },
            thumbnailPreview: null,
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            e_book_list: state => state.course.e_book,
            loading: state => state.course.courseLoading,
            error: state => state.course.courseError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("course/fetchEBook").then(() => {
            this.items = this.e_book_list
            this.totalRows = this.course_list.length;
        });
    },

    methods: {
        onImageChange(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'thumbnail') {
                    this.e_book.thumbnail = e.target.result;
                    this.thumbnailPreview = e.target.result;
                } 
            };
        },

        onImageChangeEdit(e, type) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                if(type == 'thumbnail') {
                    this.edit_e_book.thumbnail = e.target.result;
                    this.thumbnailPreview = e.target.result;
                } 
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.e_book.title = ""
            this.e_book.link = ""
            this.e_book.description = ""
            this.e_book.thumbnail = null
            this.thumbnailPreview = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("course/addEBook", {
                e_book: this.e_book
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCourse(detail) {
            this.edit_e_book.id = detail.id ? detail.id : null
            this.edit_e_book.title = detail.title ? detail.title : null
            this.edit_e_book.category = detail.category ? detail.category.id : null
            this.edit_e_book.sub_category = detail.sub_category ? detail.sub_category.id : null
            this.edit_e_book.link = detail.link ? detail.link : null
            this.edit_e_book.description = detail.description ? detail.description : null
            this.thumbnailPreview = detail.thumbnail ? this.host + detail.thumbnail : null
        },

        resetEditModal() {
            this.edit_e_book.title = ""
            this.edit_e_book.link = ""
            this.edit_e_book.description = ""
            this.edit_e_book.thumbnail = null
            this.thumbnailPreview = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("course/updateEBook", {
                id: this.edit_e_book.id,
                e_book: this.edit_e_book
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCourse(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("course/deleteEBook", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
